var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"id":"preview","src":_vm.photo,"alt":"Captured Photo"}}),_vm._v(" "),_c('button',{on:{"click":_vm.sendPhoto}},[_vm._v("Send Photo")])])}
var staticRenderFns = []

export { render, staticRenderFns }